import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ContratoService } from 'src/app/clientes/crear-contrato/contrato.service';

@Component({
  selector: 'app-otro-si',
  templateUrl: './otro-si.component.html',
  styleUrls: ['./otro-si.component.scss']
})
export class OtroSiComponent implements OnInit {
  addressForm = this.fb.group({
    company: null,
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    address: [null, Validators.required],
    address2: null,
    city: [null, Validators.required],
    state: [null, Validators.required],
    postalCode: [null, Validators.compose([
      Validators.required, Validators.minLength(5), Validators.maxLength(5)])
    ],
    shipping: ['free', Validators.required]
  });

  /**Variables de tabla */
  recurso = "contratos/admincontrato/";
  columns = ["numero", "fecha creacion", "acciones"]  ;
  params;
  nombre_tabla = 'otrosi_contrato';
  target;
  /** */
  

  constructor(private fb: FormBuilder,
              private contrato_serv : ContratoService) { }

  ngOnInit(): void {
    this.recurso += this.contrato_serv.json_contrato.id_contrato;
    this.params = {ind_otro_si : 1};
    this.target = document.querySelector('#bt_aceptar_otrosi');
  }

}
